var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeynetworkLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169,
    height: 186,
    viewBox: "0 0 169 186",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.639 22.5567L84.6304 44.1552V0.96582L62.7488 14.0961L48.639 22.5567Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.622 22.5567L84.6304 44.1552V0.96582L106.512 14.0961L120.622 22.5567Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7886 28.6288C40.0977 28.2142 39.2346 28.2142 38.5437 28.6288L1.4309 50.8963C-0.466462 52.0347 0.340663 54.9487 2.55334 54.9487H76.7789C78.9916 54.9487 79.7987 52.0347 77.9013 50.8963L40.7886 28.6288ZM130.761 28.6288C130.071 28.2142 129.207 28.2142 128.517 28.6288L91.4038 50.8963C89.5065 52.0347 90.3136 54.9487 92.5263 54.9487H166.752C168.964 54.9487 169.772 52.0347 167.874 50.8963L130.761 28.6288Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.757 59.4478H2.54542C1.34053 59.4478 0.36377 60.4245 0.36377 61.6294V70.7817C0.36377 71.9866 1.34052 72.9633 2.54541 72.9633H166.757C167.962 72.9633 168.939 71.9866 168.939 70.7817V61.6294C168.939 60.4245 167.962 59.4478 166.757 59.4478Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6733 81.8935C12.6733 79.4473 14.6564 77.4642 17.1026 77.4642H44.4155C46.8617 77.4642 48.8447 79.4473 48.8447 81.8935V164.505C48.8447 166.048 48.0424 167.479 46.7268 168.284L19.4139 184.992C16.4625 186.798 12.6733 184.674 12.6733 181.214V81.8935ZM120.457 81.8935C120.457 79.4473 122.44 77.4643 124.886 77.4643H152.199C154.645 77.4643 156.628 79.4473 156.628 81.8935V163.978C156.628 165.52 155.826 166.952 154.51 167.756L127.197 184.465C124.246 186.27 120.457 184.146 120.457 180.686V81.8935ZM69.697 77.4643C67.2508 77.4643 65.2677 79.4473 65.2677 81.8935V148.175C65.2677 149.734 66.0871 151.178 67.4253 151.977L94.7381 168.295C97.6905 170.059 101.439 167.932 101.439 164.493V81.8935C101.439 79.4473 99.456 77.4643 97.0098 77.4643H69.697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeynetworkLarge);
export default __webpack_public_path__ + "static/media/meynetwork-large.a3a16b80cae52524d2731a85e7a0453d.svg";
export { ForwardRef as ReactComponent };